module.exports = __webpack_public_path__ + "static/media/ipados_light.f05e99f8.svg";